export default __webpack_public_path__ + "78e0ed30e2697301a54397c3e3007a63.svg";